import { useState, useCallback, useEffect } from 'react';
import { MyAccountDetailsDto } from 'shared/interfaces/user/my-account-details.dto';
import { user } from 'src/api/user/user';
import i18n from 'src/i18n';

export function useUserAccountDetails() {
  const [accountDetails, setAccountDetails] = useState<MyAccountDetailsDto | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchAccountDetails = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const details = await user.getMyAccountDetails();
      setAccountDetails(details);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(i18n.t('HOOKS.USER_ACCOUNT_DETAILS.FETCH_FAILED')));
    } finally {
      setIsLoading(false);
    }
  }, []);

  const refreshAccountDetails = useCallback(async (): Promise<MyAccountDetailsDto | null> => {
    try {
      const response = await user.getMyAccountDetails();
      setAccountDetails(response);
      return response;
    } catch (error) {
      console.error('Failed to refresh user settings:', error);
      return null;
    }
  }, []);

  useEffect(() => {
    void fetchAccountDetails();
  }, [fetchAccountDetails]);

  return {
    accountDetails,
    isLoading,
    error,
    refetchAccountDetails: fetchAccountDetails,
    refreshAccountDetails,
    setAccountDetails,
  };
}
